import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=64d9621b&scoped=true&"
import script from "./DetailsTable.vue?vue&type=script&lang=ts&"
export * from "./DetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9621b",
  null
  
)

export default component.exports